module.exports = __webpack_public_path__ + "static/media/java-intermediate.d6cef1e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/validations/images/levels/java-intermediate.png
// module id = 1463
// module chunks = 147